import React from "react";

export const InfoBox = ({ showInfo, setShowInfo }) => {
  return (
    <div className={`modal-backdrop info-box ${showInfo ? "visible" : ""}`}>
      <div className="modal">
        <h1>Kikiriki online alarm clock</h1>
        <p>
          Do you find it hard to wake up? Me too, that's why I created this
          online alarm clock. Set <b>multiple alarm clocks</b>, raise the volume
          to max and go to sleep. Just make sure your computer or your mobile
          screen{" "}
          <u>
            <b>will stay awake!</b>
          </u>
        </p>
        <h2>How to set the online alarm clock?</h2>
        <ul>
          <li>Click on the plus icon to open the alarm form</li>
          <li>
            Click on the up and down arrows in the alarm clock to set the
            desired time
          </li>
          <li>Add a label, colour and sound for your alarm clock</li>
          <li>
            Click on the <b>save</b> button
          </li>
        </ul>
        <h2>How many online alarm clocks can I set?</h2>
        <p>
          You can set as many alarm clocks as you wish. Note though that you can
          not set more than one alarms at the same time. Meaning, you can not
          have two alarms set at 06:50. You can set one alarm at 06:50 and
          another one at 06:51
        </p>
        <h2>I have an idea to make this alarm clock better</h2>
        <p>
          If you have an idea to make kikiriki better, tell me about it on
          Twitter. My handle is
          <a
            className="btn btn-link"
            style={{ color: "var(--greenish)" }}
            target="blank"
            href="https://twitter.com/lefpsi"
          >
            @lefpsi
          </a>
        </p>
        <h2>What new is coming?</h2>
        <p>I have plans to add some more features on Kikiriki</p>
        <ul>
          <li>Ability to play videos from YouTube</li>
          <li>Ability to upload your own sounds</li>
        </ul>
        <button className="btn" onClick={() => setShowInfo(() => false)}>
          {showInfo ? "Hide" : "Show"} info
        </button>
      </div>
    </div>
  );
};
